// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.
import { api } from '~/redux/api/createApi';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    newAgentExecutionApiV1AgentExecutionPost: build.mutation<
      NewAgentExecutionApiV1AgentExecutionPostApiResponse,
      NewAgentExecutionApiV1AgentExecutionPostApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/agent-execution`,
        method: 'POST',
        body: queryArg.newAgentExecutionRequest,
      }),
    }),
    getExecutionApiV1AgentExecutionAgentExecutionIdGet: build.query<
      GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiResponse,
      GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/agent-execution/${queryArg.agentExecutionId}`,
      }),
    }),
    deleteAgentExecutionApiV1AgentExecutionAeIdDelete: build.mutation<
      DeleteAgentExecutionApiV1AgentExecutionAeIdDeleteApiResponse,
      DeleteAgentExecutionApiV1AgentExecutionAeIdDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/agent-execution/${queryArg.aeId}`,
        method: 'DELETE',
      }),
    }),
    listAgentExecutionsApiV1AgentExecutionsGet: build.query<
      ListAgentExecutionsApiV1AgentExecutionsGetApiResponse,
      ListAgentExecutionsApiV1AgentExecutionsGetApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/agent-executions`,
        params: {
          entity_type: queryArg.entityType,
          execution_tag: queryArg.executionTag,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createAgentExecutionMessageApiV1AgentExecutionAeIdMessagePost:
      build.mutation<
        CreateAgentExecutionMessageApiV1AgentExecutionAeIdMessagePostApiResponse,
        CreateAgentExecutionMessageApiV1AgentExecutionAeIdMessagePostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/agent-execution/${queryArg.aeId}/message`,
          method: 'POST',
          body: queryArg.agentExecutionMessageRequest,
        }),
      }),
    interruptAgentExecutionApiV1AgentExecutionAeIdInterruptPost: build.mutation<
      InterruptAgentExecutionApiV1AgentExecutionAeIdInterruptPostApiResponse,
      InterruptAgentExecutionApiV1AgentExecutionAeIdInterruptPostApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/agent-execution/${queryArg.aeId}/interrupt`,
        method: 'POST',
      }),
    }),
    getAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPost:
      build.mutation<
        GetAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPostApiResponse,
        GetAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/agent-execution/${queryArg.aeId}/ai-message/stream`,
          method: 'POST',
        }),
      }),
    updateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatch: build.mutation<
      UpdateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatchApiResponse,
      UpdateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/agent-execution/${queryArg.aeId}/message/${queryArg.messageId}`,
        method: 'PATCH',
        body: queryArg.updateAgentExecutionMessageRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type NewAgentExecutionApiV1AgentExecutionPostApiResponse =
  /** status 201 Create a new Agent Execution.

The endpoint accepts an agent_type enum and agent_configuration object along with an option execution_tag.
- agent_type: defines the type of agent that will run under this execution, e.g. ask_ai, ai_playbook, etc...
- agent_configuration: defines the starting configuration for the agent. It will contains references to objects that the
    agent requires in order to initialize and it depends on the type of agent being executed.
    For example: ask_ai may have information about starting scope and type of ask conversation. Whereas ai_playbook will
    have references to the playbook being run and the targeted ticket.
- execution_tag: an optional string that can also be provided to the list agent executions for grouping executions.

Creating the agent execution will initialize the agent by running the agent specific prepare method as an async
background task. This method will form a message stream that the ai-stream endpoint will listen on before processing
a user message. This stream is used to pass status messages from the prepare method to a waiting user via the thinking
events. When the prepare method completes, it will close the prepare stream, and the agent will be initialized and it
can start handling any user inputs expected by that agent.

Creating an agent-execution creates an internal conversation object that must be referenced by uuid. All interactions
with the agent execution must use the uuid returned from the create agent-execution endpoint.

 */ AgentExecution;
export type NewAgentExecutionApiV1AgentExecutionPostApiArg = {
  newAgentExecutionRequest: NewAgentExecutionRequest;
};
export type GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiResponse =
  /** status 200 Successful Response */ AgentExecution;
export type GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiArg = {
  agentExecutionId: string;
};
export type DeleteAgentExecutionApiV1AgentExecutionAeIdDeleteApiResponse =
  /** status 204 Successful Response */ void;
export type DeleteAgentExecutionApiV1AgentExecutionAeIdDeleteApiArg = {
  aeId: string;
};
export type ListAgentExecutionsApiV1AgentExecutionsGetApiResponse =
  /** status 200 Lists the agent executions started by the requesting user.

The endpoint will return a list of agent-executions that the requesting user started.
This endpoint accepts an optional parameter, execution_tag, which will return only the executions created with
the respective tag.

 */ PageAgentExecution;
export type ListAgentExecutionsApiV1AgentExecutionsGetApiArg = {
  entityType?: ExternalEntityType | null;
  executionTag?: string | null;
  /** Page number */
  page?: number;
  /** Page size */
  size?: number;
};
export type CreateAgentExecutionMessageApiV1AgentExecutionAeIdMessagePostApiResponse =
  /** status 201 Sends user input the the agent execution in the form of the AgentExecutionMessage.

This message will be added to the underlying conversation for the agent, and will be processed with the next ai-stream
call.

 */ AgentExecutionMessage;
export type CreateAgentExecutionMessageApiV1AgentExecutionAeIdMessagePostApiArg =
  {
    aeId: string;
    agentExecutionMessageRequest: AgentExecutionMessageRequest;
  };
export type InterruptAgentExecutionApiV1AgentExecutionAeIdInterruptPostApiResponse =
  /** status 202 Successful Response */ any;
export type InterruptAgentExecutionApiV1AgentExecutionAeIdInterruptPostApiArg =
  {
    aeId: string;
  };
export type GetAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPostApiResponse =
  /** status 201 Request that the AI continue the agent execution with the last submitted user
message, and stream the response as AgentExecutionStreamEvent objects.

This endpoint streams the response messages from the bot using SSE (Server Sent Events).

The message return type is not actually application/json, but text/event-stream. Each event data will be json
of the specified `AgentExecutionStreamEvent` schema.

The supported event types is expanding with newly supported agents.

| `event_type`                  | Description                                                                                                                                  | Recommended FE action                                                                                                                                                                                                              | has `text`  | has `message` |
|-------------------------------|----------------------------------------------------------------------------------------------------------------------------------------------|------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|-------------|---------------|
| `thinking`                    | Sylvanus is processing.<br>May include a user-friendly description of what is being processed.                                               | display loading icon<br>optionally display `text` promptmodel to user                                                                                                                                                                    | optional    | no            |
| `message_start`               | A new message will be generated.<br>Expect a stream of `delta` events, potentially interspersed with<br>`message_response_suggestion_events` | prepare for new message, e.g.:<br>- initialize empty message data<br>- create empty message box                                                                                                                                    | no          | no            |
| `message_delta`               | A fragment of the current message.<br>Not guaraunteed to be any particular length.                                                           | - add the text to the current message data<br>- reformat the message data as html and display to the user                                                                                                                          | yes         | no            |
| `message_response_suggestion` | Represents a suggestion to the user for their next response.<br>Extracted from the current message text.                                     | - search for the `text` from this message in the current message data<br>- replace that text with a button allowing the user to use that suggestion                                                                                | yes         | no            |
| `message_end`                 | The message is finished. Also contains message metadata like `id`, <br>`datetime_created` , `allowable_user_actions` etc.                    | - add the message metadata to the message object<br>- finalize display of the message to the user<br>- allow the user to perform the `allowable_user_actions`<br>- prepare for (potentially) another message in the current stream | no          | yes           |
| `stream_end`                  | This stream of messages has finished                                                                                                         | - close the stream object<br>- allow the user to send messages again                                                                                                                                                               | no          | no            |
 */ AgentExecutionStreamEvent;
export type GetAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPostApiArg =
  {
    aeId: string;
  };
export type UpdateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatchApiResponse =
  /** status 200 Successful Response */ AgentExecutionMessage;
export type UpdateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatchApiArg =
  {
    aeId: string;
    messageId: number;
    updateAgentExecutionMessageRequest: UpdateAgentExecutionMessageRequest;
  };
export type AgentType = 'ask_ai' | 'ai_edit' | 'ai_playbook' | 'wf_router';
export type ExternalEntityType =
  | 'document_handler'
  | 'document_version'
  | 'document_external_id'
  | 'field'
  | 'document_id'
  | 'all_documents'
  | 'ticket'
  | 'conversation_message'
  | 'model'
  | 'document_attached_data'
  | 'agent_execution'
  | 'ai_playbook_id';
export type ExternalEntity = {
  id: string;
  type: ExternalEntityType;
};
export type AgentConfiguration = {
  external_entities?: ExternalEntity[] | null;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type ConversationRoles = 'user' | 'bot';
export type AgentMessageType = 'query' | 'command' | 'followup' | 'action';
export type MessageContext = {
  /** Optional search query to limit scope. */
  search_query?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Entity to be searched in search_query. */
  search_entity?: string | null;
  /** the selected pilot document_ids */
  selected_ids?: string[] | null;
  /** the selected entities for the scope. currently storing pilot doc handlers. */
  entities_in_view?: ExternalEntity[] | null;
  /** Type of message, ex: query, command... */
  message_type?: AgentMessageType | null;
};
export type HighlightRect = {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
  width: number;
  height: number;
  pageNumber: number;
  pageRotation: number;
};
export type HightlightingRects = {
  rects: HighlightRect[];
  pageNumber: number;
};
export type HighlightingCoordinates = {
  source: string;
  coordinates: HightlightingRects;
  token_ids: number[];
};
export type DocumentHighlightSource = {
  name?: string;
  coordinates?: HighlightingCoordinates[] | null;
  html_tokens?: number[];
  text?: string | null;
};
export type Citation = {
  /** the data UI doc viewer needs in order to render the original_quote */
  highlights: DocumentHighlightSource[];
  /** the entity being cited */
  entity: ExternalEntity | null;
  /** the name of the entity being cited */
  entity_name?: string | null;
  /** UI url to render the citation */
  link: string | null;
  /** AiCitation -> AiCitationOptionalData -> tooltip */
  tooltip: string | null;
  /** AiCitation -> AiCitationOptionalData -> original_quote */
  original_quote: string | null;
};
export type MessageActions =
  | 'convert_to_extraction_model'
  | 'convert_to_classification_model'
  | 'save_message'
  | 'share_message';
export type UserRating = 'positive' | 'negative';
export type AgentExecutionMessage = {
  id: string;
  ae_id: string;
  role: ConversationRoles;
  message_text?: string | null;
  message_context: MessageContext | null;
  datetime_created: string;
  response_suggestions?: string[] | null;
  sources?: DocumentHighlightSource[];
  citations?: {
    [key: string]: Citation;
  };
  allowable_user_actions?: MessageActions[];
  user_rating?: UserRating | null;
  user_comment?: string | null;
  user_feedback_category?: string | null;
  /** Additional agent-specific data (e.g., workflow recommendations for WRA) */
  additional_info?: {
    [key: string]: any;
  };
};
export type AgentExecution = {
  id: string;
  datetime_created: string;
  created_by_user_id: string;
  created_by_user_email: string;
  agent_type: AgentType;
  agent_configuration: AgentConfiguration;
  execution_tag?: string | null;
  messages: AgentExecutionMessage[];
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type AgentConfiguration2 = {
  external_entities?: ExternalEntity[] | null;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type NewAgentExecutionRequest = {
  agent_type: AgentType;
  agent_configuration: AgentConfiguration2;
  execution_tag?: string | null;
};
export type PageAgentExecution = {
  items: AgentExecution[];
  total: number | null;
  page: number | null;
  size: number | null;
  pages?: number | null;
};
export type MessageContext2 = {
  /** Optional search query to limit scope. */
  search_query?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Entity to be searched in search_query. */
  search_entity?: string | null;
  /** the selected pilot document_ids */
  selected_ids?: string[] | null;
  /** the selected entities for the scope. currently storing pilot doc handlers. */
  entities_in_view?: ExternalEntity[] | null;
  /** Type of message, ex: query, command... */
  message_type?: AgentMessageType | null;
};
export type AgentExecutionMessageRequest = {
  /** Text of the message to send to the AI. Maximum length is 1000 words / 10000 characters. */
  message: string;
  context: MessageContext2;
  metadata?: {
    [key: string]: string;
  };
};
export type AgentExecutionStreamEventType =
  | 'thinking'
  | 'message_context'
  | 'message_start'
  | 'message_delta'
  | 'message'
  | 'message_response_suggestion'
  | 'message_source'
  | 'message_end'
  | 'stream_end'
  | 'message_citations';
export type AgentExecutionStreamEvent = {
  event_type: AgentExecutionStreamEventType;
  text?: string | null;
  message?: AgentExecutionMessage | null;
  message_context?: MessageContext | null;
};
export type UpdateAgentExecutionMessageRequest = {
  user_rating?: UserRating | null;
  user_comment?: string | null;
  user_feedback_category?: string | null;
};
